import qs from 'qs';
import _omitBy from 'lodash/omitBy';
import _isEmpty from 'lodash/isEmpty';
import _isUndefined from 'lodash/isUndefined';
import smbUtils from './smbUtils';
import langUtils from './langUtils';
import i18n from 'i18next';

const utils = {
  isPartnerSite: () => window.location.pathname.startsWith('/partner'),
  genReferralLink: (
    ref = undefined,
    source = undefined,
    medium = undefined,
    campaign = undefined,
    content = undefined
  ) => {
    const q = _omitBy(
      {
        ref: ref,
        utm_source: source,
        utm_medium: medium,
        utm_campaign: campaign,
        utm_content: content,
      },
      _isEmpty || _isUndefined
    );
    return (
      smbUtils.getUrl() +
      langUtils.convertToFrontendLangUrl(i18n.language) +
      '/business/plan?' +
      qs.stringify(q)
    );
  },
  escapeRegExp: str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
};

export default utils;
